import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import style from "./Scrollbar.module.scss";

interface ScrollbarProps {
  children: React.ReactNode;
}

const Scrollbar: React.FC<ScrollbarProps> = ({ children }) => {
  return (
    <Scrollbars
      renderTrackVertical={(props) => <div {...props} className={style.scrollbar__trackY} />}
      renderThumbVertical={(props) => <div {...props} className={style.scrollbar__thumbY} />}
      className={style.scrollbar}
    >
      <div className={style.scrollbar__content}>{children}</div>
    </Scrollbars>
  );
};

export default Scrollbar;
